import { render, staticRenderFns } from "./cv-combo-box.vue?vue&type=template&id=c72589a2&"
import script from "./cv-combo-box.vue?vue&type=script&lang=js&"
export * from "./cv-combo-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports